const amountOfCoreUsersOnPage = 20;

export default amountOfCoreUsersOnPage;
